import { motion } from 'framer-motion';

// Official SVG logos for each platform
const SpotifyLogo = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);

const AppleMusicLogo = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.994 6.124a9.23 9.23 0 00-.24-2.19c-.317-1.31-1.062-2.31-2.18-3.043a5.022 5.022 0 00-1.877-.726 10.496 10.496 0 00-1.564-.15c-.04-.003-.083-.01-.124-.013H5.986c-.152.01-.303.017-.455.026-.747.043-1.49.123-2.193.4-1.336.53-2.3 1.452-2.865 2.78-.192.448-.292.925-.363 1.408-.056.392-.088.785-.1 1.18 0 .032-.007.062-.01.093v12.223c.01.14.017.283.027.424.05.815.154 1.624.497 2.373.65 1.42 1.738 2.353 3.234 2.801.42.127.856.187 1.293.228.555.053 1.11.06 1.667.06h11.03c.525 0 1.048-.034 1.57-.1.823-.106 1.597-.35 2.296-.81a5.046 5.046 0 001.88-2.207c.186-.42.293-.87.37-1.324.113-.675.138-1.358.137-2.04-.002-3.8 0-7.595-.003-11.393zm-6.423 3.99v5.712c0 .417-.058.827-.244 1.206-.29.59-.76.962-1.388 1.14-.35.1-.706.157-1.07.173-.95.042-1.8-.6-1.965-1.483-.18-.965.39-1.927 1.343-2.217.428-.13.872-.2 1.314-.257.404-.053.81-.1 1.2-.19.265-.063.373-.186.38-.466.004-.085 0-.17 0-.255V8.498c0-.2-.054-.254-.253-.224-.473.07-.946.143-1.42.214l-4.09.617c-.067.01-.134.025-.2.04-.122.03-.184.107-.19.233-.003.063 0 .127 0 .19v7.79c0 .282-.014.56-.09.832-.22.793-.755 1.303-1.5 1.554-.353.118-.72.18-1.09.21-.934.075-1.808-.483-2.063-1.346-.265-.892.13-1.856 1.003-2.293.32-.16.664-.255 1.018-.306.466-.066.933-.12 1.4-.188.305-.045.467-.212.49-.515.004-.062.002-.125.002-.188V7.078c0-.323.086-.453.397-.51.503-.093 1.005-.19 1.508-.285l3.326-.63 2.436-.46c.32-.06.637-.13.956-.19.11-.02.168.02.2.128.015.052.02.107.02.16v4.822z"/>
  </svg>
);

const AmazonMusicLogo = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 448 512" fill="currentColor">
    <path d="M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26-21.6 31-5.5 4.5-11 4.3-8-2.3l17-34.7c2.8-6.2 4.8-12.3 4.8-17 0-6.3-7.3-12-17-12H368c-6.5 0-10-4-6.5-8.3 9.3-11.5 24-13.5 35-13.5 17.5 0 54.5 6.3 54.5 38.3 0 8-3.5 13.5-18 18.5z"/>
  </svg>
);

const TidalLogo = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.012 3.992L8.008 7.996 4.004 3.992 0 7.996 4.004 12l4.004-4.004L12.012 12l4.004-4.004L20.02 12l4.004-4.004-4.004-4.004-4.004 4.004-4.004-4.004zM12.012 12.004l-4.004 4.004 4.004 4.004 4.004-4.004-4.004-4.004z"/>
  </svg>
);

const platforms = [
  {
    name: 'Spotify',
    Logo: SpotifyLogo,
    color: '#1DB954',
    url: 'https://open.spotify.com/artist/3qb1YMxzLPO7HZnQowycUj',
  },
  {
    name: 'Apple Music',
    Logo: AppleMusicLogo,
    color: '#FC3C44',
    url: 'https://music.apple.com/us/artist/white-rabbit-bangers/1859082521',
  },
  {
    name: 'Amazon Music',
    Logo: AmazonMusicLogo,
    color: '#FF9900',
    url: 'https://music.amazon.com/artists/B0G5FPTHFK/white-rabbit-bangers',
  },
  {
    name: 'Tidal',
    Logo: TidalLogo,
    color: '#00FFFF',
    url: 'https://tidal.com/artist/70876723',
  },
];

interface StreamingLinksProps {
  variant?: 'horizontal' | 'vertical';
  size?: 'sm' | 'md' | 'lg';
}

export default function StreamingLinks({ variant = 'horizontal', size = 'md' }: StreamingLinksProps) {
  const sizeStyles = {
    sm: 'text-xl p-2',
    md: 'text-2xl p-3',
    lg: 'text-3xl p-4',
  };

  const containerStyles = variant === 'horizontal' 
    ? 'flex flex-wrap justify-center gap-4'
    : 'flex flex-col gap-3';

  return (
    <div className={containerStyles}>
      {platforms.map((platform, index) => (
        <motion.a
          key={platform.name}
          href={platform.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`
            ${sizeStyles[size]}
            inline-flex items-center gap-3
            bg-cyber-dark/60 backdrop-blur-sm
            border border-white/10 rounded-xl
            transition-all duration-300
            hover:border-opacity-50
            group
          `}
          style={{
            ['--platform-color' as string]: platform.color,
          }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          whileHover={{ 
            scale: 1.05,
            borderColor: platform.color,
            boxShadow: `0 0 30px ${platform.color}40`,
          }}
          whileTap={{ scale: 0.95 }}
        >
          <div style={{ color: platform.color }}>
            <platform.Logo className="transition-all duration-300 w-6 h-6" />
          </div>
          {variant === 'vertical' && (
            <span className="font-rajdhani font-medium text-white/80 group-hover:text-white">
              {platform.name}
            </span>
          )}
        </motion.a>
      ))}
    </div>
  );
}

